// The bet as the table holds it before it is placed: which market, which way, the stake, the
// speed (leverage) and the payout that cashes it out. The arena draws it; the rail edits it.

import { prefs } from "../state/prefs";
import { createStore } from "../state/store";

export type Call = "up" | "down";

/** Cash out when the payout reaches this multiple of the stake; null rides to a manual close. */
export type Target = 1.5 | 2 | 3 | 5 | 10 | null;

/** Cash out after this long whatever the payout; null never. */
export type Clock = 60_000 | 300_000 | 900_000 | 3_600_000 | null;

export type Slip = {
  coin: string;
  call: Call;
  /** Dollars, as typed. */
  stake: string;
  leverage: number;
  target: Target;
  clock: Clock;
};

export const TARGETS: Exclude<Target, null>[] = [2, 3, 5, 10];
export const CLOCKS: { value: Clock; label: string }[] = [
  { value: null, label: "Off" },
  { value: 60_000, label: "1m" },
  { value: 300_000, label: "5m" },
  { value: 900_000, label: "15m" },
  { value: 3_600_000, label: "1h" },
];

/** Chips a stake is built from, in dollars. */
export const CHIPS = ["10", "25", "100", "500"] as const;

/** Leverage as the table speaks it: how fast the bet is likely to settle. */
export const PACES = [
  { leverage: 500, name: "Fast" },
  { leverage: 250, name: "Normal" },
  { leverage: 100, name: "Slow" },
] as const;

export const paceName = (leverage: number) => PACES.find((pace) => pace.leverage === leverage)?.name ?? `${leverage}×`;

const DEFAULTS: Slip = { coin: "BTC", call: "up", stake: "25", leverage: 250, target: 2, clock: null };

const kept = prefs.get().leverage.__slip;
const known = PACES.some((pace) => pace.leverage === kept);
export const slip = createStore<Slip>({ ...DEFAULTS, leverage: known && kept ? kept : DEFAULTS.leverage });

export function setSlip(next: Partial<Slip>) {
  slip.set((state) => ({ ...state, ...next }));
  if (next.leverage) prefs.set((all) => ({ ...all, leverage: { ...all.leverage, __slip: next.leverage as number } }));
}
